import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import { LedgerAccountFragment } from 'generated/resources/graphql'

import { formatAccountName } from 'modules/banking/components/LedgerAccountSelector'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

interface JournalEntryLineRowProps {
  lineId: number
  selectedLedgerAccount?: LedgerAccountFragment
  debitAmountCents: number
  creditAmountCents: number
  currency: string
  locale: string
}

export const JournalEntryLineRow = ({
  lineId,
  selectedLedgerAccount,
  debitAmountCents,
  creditAmountCents,
  currency,
  locale,
}: JournalEntryLineRowProps) => {
  return (
    <Table.Row key={lineId}>
      <Table.Cell padding="s0" style={{ height: '64px' }}>
        <Box paddingLeft="s12">
          <Box paddingLeft={'s4'} height="s64" justifyContent="center">
            <Text.Normal size="300" weight="medium" lineClamp={2}>
              {formatAccountName(selectedLedgerAccount)}
            </Text.Normal>
          </Box>
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s8" width={130}>
        <Box height="full">
          <Box paddingLeft={'s16'} justifyContent="center">
            <Text.Normal size="300" weight="medium" lineClamp={1}>
              {debitAmountCents
                ? formattedAmount({ amountCents: debitAmountCents, currency, locale })
                : ''}
            </Text.Normal>
          </Box>
        </Box>
      </Table.Cell>
      <Table.Cell padding="s0" width={130}>
        <Box height="full">
          <Box paddingLeft={'s16'} justifyContent="center">
            <Text.Normal size="300" weight="medium" lineClamp={1}>
              {creditAmountCents
                ? formattedAmount({ amountCents: creditAmountCents, currency, locale })
                : ''}
            </Text.Normal>
          </Box>
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}
